"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_intl_1 = require("react-intl");
const react_design_system_1 = require("@hdh-core/react-design-system");
const transactionSigningSelector_1 = require("@/features/transaction-signing/selectors/transactionSigningSelector");
const transactionSigningAction_1 = require("../../transaction-signing/actions/transactionSigningAction");
const dompurify_1 = __importDefault(require("dompurify"));
require("../../transaction-signing/containers/HardToken.css");
const R4TransactionSigningOneToken = ({ onClose }) => {
    const intl = (0, react_intl_1.useIntl)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { expirySecs } = (0, react_redux_1.useSelector)(transactionSigningSelector_1.transactionSigningSelector);
    const [startTimer, setStartTime] = (0, react_1.useState)(false);
    const [timer, setTimer] = (0, react_1.useState)(expirySecs);
    const breakLine = (text) => {
        const regex = /(<br\s*\/?>)/g;
        return text.split(regex).map(function (line, index) {
            return line.match(regex) ? react_1.default.createElement("br", { key: 'key_' + index }) : line;
        });
    };
    const handleToggleCloseR4OneToken = () => {
        setStartTime(false);
        dispatch((0, transactionSigningAction_1.endAuthorizationStatus)());
        dispatch((0, transactionSigningAction_1.toggleCloseOneToken)());
        onClose();
    };
    const handleToggleSWKResendNotificationR4 = () => {
        dispatch((0, transactionSigningAction_1.toggleSWKResendNotification)());
        setTimer(expirySecs);
    };
    (0, react_1.useEffect)(() => {
        //NOSONAR
        if (startTimer) {
            const intervalId = setInterval(() => {
                setTimer(t => t - 1);
            }, 1000);
            if (timer <= 0) {
                clearInterval(intervalId);
            }
            return () => clearInterval(intervalId);
        }
        return null;
    }, [timer, startTimer]);
    console.log('R4TransactionSigning');
    console.log('R4 window', window);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_design_system_1.Box, { pt: '2xl', pl: '2xl', pr: '2xl', className: 'in-iframe' },
            react_1.default.createElement(react_design_system_1.Box, { justifyContent: 'center', alignItems: 'center' },
                react_1.default.createElement(react_design_system_1.Illustration, { name: 'soft-token', width: '200', height: '200', alt: intl.formatMessage({ id: 'transaction-signing-soft-token-title' }), className: 'rds-mx-auto' })),
            react_1.default.createElement(react_design_system_1.Text, { component: 'div', size: '2xl', bold: true, color: '#333739', className: 'rds-text-center rds-mb-xs' }, breakLine(intl.formatMessage({ id: 'transaction-signing-soft-token-title' }))),
            react_1.default.createElement("div", { className: `
                        rds-font-body rds-select-none rds-font-normal rds-text-sm rds-text-neutral-80 rds-text-center
                        rds-whitespace-pre-wrap rds-break-words
                    `, dangerouslySetInnerHTML: {
                    __html: dompurify_1.default.sanitize(intl.formatMessage({ id: 'transaction-signing-msg' }), { ADD_ATTR: ['target'] }),
                } }),
            react_1.default.createElement(react_design_system_1.Flex, { flexDirection: 'row', justifyContent: 'center', mt: 'md' },
                react_1.default.createElement(react_design_system_1.Text, { component: 'div', size: 'sm', color: '#575A5C', className: 'rds-text-center rds-whitespace-pre-wrap rds-break-words' },
                    intl.formatMessage({ id: 'transaction-signing-timeRemaining' }),
                    " :"),
                react_1.default.createElement(react_design_system_1.Text, { component: 'div', size: 'sm', color: '#CC0000', className: 'rds-ml-2xs rds-text-center rds-whitespace-pre-wrap rds-break-words' }, timer + intl.formatMessage({ id: 'transaction-signing-second' })))),
        react_1.default.createElement(react_design_system_1.Box, { p: '2xl', className: 'in-iframe' },
            react_1.default.createElement(react_design_system_1.Flex, { flexDirection: 'col', className: 'rds-w-full' },
                react_1.default.createElement(react_design_system_1.Flex, { flexDirection: 'row' },
                    react_1.default.createElement(react_design_system_1.Button, { id: intl.formatMessage({ id: 'common.button.btnCancel' }), fullWidth: true, secondary: true, className: 'rds-mr-xs', onClick: handleToggleCloseR4OneToken }, intl.formatMessage({ id: 'common.button.btnCancel' })),
                    react_1.default.createElement(react_design_system_1.Button, { id: intl.formatMessage({ id: 'common.button.btnResend' }), disabled: timer !== 0, fullWidth: true, className: 'rds-ml-xs', onClick: handleToggleSWKResendNotificationR4 }, intl.formatMessage({ id: 'common.button.btnResend' }))),
                react_1.default.createElement(react_design_system_1.Box, null,
                    react_1.default.createElement(react_design_system_1.Divider, { component: 'div', className: 'rds-py-xl' }),
                    react_1.default.createElement(react_design_system_1.Box, { className: "rds-text-center" },
                        react_1.default.createElement(react_design_system_1.Text, { className: "rds-text-sm rds-text-center", isHTMLTextFormatting: true, htmlText: intl.formatMessage({ id: 'transaction-signing-notReceivedNotification' }) }))))),
        !startTimer ? setStartTime(true) : null));
};
exports.default = R4TransactionSigningOneToken;
